<template>
  <div class="login-pop">
    <div class="login-content" v-loading="loading">
      <div class="login-box">
        <div class="login-close">
          <img
            @click="closeLoginView"
            style="width: 20px; height: 20px"
            src="../assets/images/icon12.png"
          />
        </div>
        <div class="login-logo"><img src="../assets/images/logo2.png" /></div>
        <ul class="login-ul">
          <li>
            <input
              class="li-input"
              placeholder="请输入账号"
              v-model.trim="form.phone"
            />
          </li>
          <li>
            <input
              class="li-input"
              placeholder="请输入密码"
              type="password"
              v-model.trim="form.password"
            />
          </li>
        </ul>
        <button class="login-btn" @click="getLoginData">登录</button>
        <div class="login-bot"><img src="../assets/images/l1.png" /></div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { getAccount, login } from "@/api/home";
import { date2str, encryptByDES } from "@/utils/login_crypto";
import { ElMessage } from "element-plus";
import { onMounted, reactive, toRefs } from "vue";
const state = reactive({
  form: {
    phone: "",
    password: "",
  },
  loading: false,
  loginStatus: false,
});
const { form, loading } = toRefs(state);
// 传递给父组件
const emits = defineEmits(["loginResult", "acceptUserName"]);

// 关闭
const closeLoginView = () => {
  state.loginStatus = false;
  emits("loginResult", false);
};

// 登录
const getLoginData = () => {
  if (!validateParams()) return;

  state.loading = true;
  let nowtime = date2str(new Date(), "yyyyMMdd");
  let param = {
    txt3: encryptByDES(state.form.phone, nowtime + "microcloud"),
    txt4: encryptByDES(state.form.password, nowtime + "microcloud"),
    grant_type: "password",
    client_id: "tester",
    client_secret: "tester",
  };
  state.loginStatus = true;
  if (state.loginStatus) {
    login(param)
      .then((res) => {
        if (res.access_token) {
          localStorage.setItem("token", res.access_token);
          getAccountInfo();
        } else {
          ElMessage.error("用户名或密码错误，登录失败，请重试");
          state.loading = false;
        }
      })
      .catch((err) => {
        ElMessage.error(err.response.data.msg);
        state.loading = false;
        state.loginStatus = false;
      });
  }
};

// 账号角色查询
const getAccountInfo = (data) => {
  getAccount()
    .then((res) => {
      console.log(res);
      state.loading = false;
      state.loginStatus = false;
      if (res.resp_code == 200) {
        // console.log("信息", res);
        if (res.user.sysRoles[0])
          localStorage.setItem(
            "roleInfo",
            JSON.stringify(res.user.sysRoles[0])
          );
        localStorage.setItem("phone", state.form.phone);
        localStorage.setItem("password", state.form.password);
        ElMessage.success("登录成功");
        emits("loginResult", false); //登录成功，关闭登录弹窗
        if (res.user.username) {
          localStorage.setItem("userName", res.user.name);
          emits("acceptUserName", res.user.name);
        }
      } else {
        ElMessage.error("用户名或密码错误，登录失败，请重试");
        state.loading = false;
      }
    })
    .catch((err) => {
      ElMessage.error(err.response.data.msg);
      state.loading = false;
      state.loginStatus = false;
    });
};

// 参数校验
const validateParams = () => {
  if (!state.form.phone) {
    ElMessage.error("请输入账号");
    return false;
  }
  if (!state.form.password) {
    ElMessage.error("请输入密码");
    return false;
  }
  return true;
};

onMounted(() => {
  //从缓存获取上次登录的账号密码
  let phone = localStorage.getItem("phone");
  let password = localStorage.getItem("password");
  if (phone) {
    state.form.phone = phone;
  }
  if (password) {
    state.form.password = password;
  }
});
</script>
<style lang="scss" scoped>
.login-pop {
  position: fixed;
  z-index: 99999;
  top: 0;
  left: 0;

  width: 100%;
  height: 100%;

  background: rgba(0, 0, 0, 0.5);

  .login-content {
    position: relative;

    display: flex;
    align-items: center;
    justify-content: center;

    width: 100%;
    height: 100%;
  }

  .login-box {
    width: 800px;
    padding: 36px 0;

    background: #fff;

    .login-close {
      display: flex;
      align-items: center;
      justify-content: flex-end;

      margin-right: 35px;
    }
  }

  .login-logo {
    margin: 40px 0 35px 0;

    img {
      display: block;

      width: 600px;
      margin: 0 auto;
    }
  }

  .login-ul {
    max-width: 600px;
    margin: 0 auto;

    li {
      height: 70px;
      margin: 60px 0;
      padding: 0 20px;

      border: 1px solid #ccc;
      background: #fff;

      .li-input {
        width: 100%;
        height: 70px;

        font-size: 28px;
      }
    }
  }

  .login-btn {
    display: block;

    width: 600px;
    height: 70px;
    margin: 60px auto;

    text-align: center;

    color: #fff;
    border: none;
    outline: none;
    background: #0ba29a;

    font-size: 32px;

    .login-bot {
      margin: 80px 50px 0 50px;

      img {
        display: block;

        max-width: 100%;
        margin: 0 auto;
      }
    }
  }

  // .el-alert {
  //   margin: 20px 0 0;
  // }

  // .el-alert:first-child {
  //   margin: 0;
  // }

  // .alert {
  //   position: absolute;
  //   bottom: 20%;
  //   left: 50%;

  //   width: 400px;
  //   height: 100px;

  //   transform: translateX(-50%);
  // }
}
</style>
